// generated from 265 samples

import { z } from "zod";

export const catalogBackInStockTriggerGetSchema = z.object({
  event_type: z.literal("TrackedUserBehavior::CatalogBackInStock"),
  // null: 152 (57.36%)
  catalog_name: z.string().nullable(),
  subscription_type: z.null(),
});
